<template>
  <div class="slider-inner slider-g">
    <Logo />

    <img class="j1 animated zoomIn" src="~images/g/g_1.png" />
    <div class="j2 animated fadeInUpBig">
      <div class="inner">
        <img class="g2_1 animated zoomIn" src="~images/g/g_2.png" alt="" />
        <img class="g2_2 animated zoomIn" src="~images/g/g_3.png" alt="" />
        <img class="g2_3 animated zoomIn" src="~images/g/g_4.png" alt="" />
        <img class="g2_4 animated zoomIn" src="~images/g/g_5.png" alt="" />
        <img class="g2_5 animated zoomIn" src="~images/g/g_6.png" alt="" />
        <img class="g2_6 animated zoomIn" src="~images/g/g_7.png" alt="" />
      </div>
    </div>
    <img class="j3 animated fadeInLeft" src="~images/j/j_6.png" alt="" />
    <img class="j4 animated fadeInRight" src="~images/j/j_5.png" alt="" />
    <img class="j5 animated fadeInLeft" src="~images/j/j_4.png" alt="" />
    <img class="j9 animated fadeInRight" src="~images/j/j_3.png" alt="" />
    <img class="j6 animated fadeInLeft" src="~images/j/j_left.png" alt="" />
    <img class="j7 animated fadeInRight" src="~images/j/j_right.png" alt="" />

    <Tip />
  </div>
</template>

<script>
export default {
  name: "SliderG",
};
</script>

<style lang="less" scoped>
.slider-g {
  background: url("~images/a/bg.jpg") center top / 100% no-repeat;
  background-size: 100% 100%;
  .j1 {
    width: 60%;
    position: absolute;
    top: 14%;
    left: 20%;
    z-index: 1;
    animation-delay: 0.4s;
  }
  .j2 {
    width: 90%;
    background: url("~images/g/g_box.png") center top / 100% no-repeat;
    position: absolute;
    top: 20%;
    left: 5%;
    right: 5%;
    bottom: 18%;
    box-sizing: border-box;
    padding: 0.5rem 0.15rem;
    overflow-y: auto;
    overflow: hidden;
    .inner {
      position: relative;
      height: 100%;
      margin: 0 0.2rem;
      overflow: auto;
      img {
        position: absolute;
        top: 3%;
        left: 0;
        width: 100%;
      }
      .g2_1 {
        animation-delay: 0.8s;
      }
      .g2_2 {
        animation-delay: 1s;
      }
      .g2_3 {
        animation-delay: 1.2s;
      }
      .g2_4 {
        animation-delay: 1.4s;
      }
      .g2_5 {
        animation-delay: 1.6s;
      }
      .g2_6 {
        animation-delay: 1.8s;
      }
    }
  }
  .j3 {
    width: 0.53rem;
    position: absolute;
    top: 15%;
    left: 12%;
    animation-delay: 0.8s;
  }
  .j4 {
    width: 0.8rem;
    position: absolute;
    top: 43%;
    right: 2%;
    animation-delay: 0.8s;
  }
  .j5 {
    width: 0.77rem;
    position: absolute;
    top: 65%;
    left: 4%;
    animation-delay: 0.8s;
  }
  .j6 {
    width: 3.65rem;
    position: absolute;
    bottom: 0%;
    left: 0%;
    animation-duration: 2s;
  }
  .j7 {
    width: 3.48rem;
    position: absolute;
    bottom: 0%;
    right: 0;
    animation-duration: 1.5s;
  }
  .j9 {
    width: 1.44rem;
    position: absolute;
    top: 16%;
    right: 0%;
    animation-delay: 0.8s;
  }
}
</style>
